import { render, staticRenderFns } from "./BudgetCaps.vue?vue&type=template&id=4a038fa4&"
import script from "./BudgetCaps.vue?vue&type=script&lang=js&"
export * from "./BudgetCaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports